// Upcoming group departures for /proximas_salidas
// Real-world structure: dates, route, places left, price, status.

// Keep unpublished departures available for future reuse, without displaying
// them in the hub or any of its homepage/category previews.
const DEPARTURE_CATALOG = [
  {
    id: "nye-2026",
    tripRouteId: "tourFinDeAno2025",
    published: true,
    featured: true,
    badge: { es: "Año Nuevo 2027", en: "New Year 2027", fr: "Nouvel An 2027" },
    badgeColor: "#D4A373",
    title: {
      es: "Viaje Especial de Fin de Año al Desierto de Marruecos",
      en: "Special New Year journey to the Moroccan desert",
      fr: "Voyage spécial du Nouvel An dans le désert marocain",
    },
    dates: { es: "27 Dic 2026 – 01 Ene 2027", en: "27 Dec 2026 – 01 Jan 2027", fr: "27 Déc 2026 – 01 Jan 2027" },
    nights: { es: "5 noches · 6 días", en: "5 nights · 6 days", fr: "5 nuits · 6 jours" },
    image: "https://images.unsplash.com/photo-1547234935-80c7145ec969?auto=format&fit=crop&w=2000&q=85",
    price: 1980,
    childPrice: 1540,
    airportTaxes: 120,
    singleSupplement: 335,
    deposit: null,
    spots: null,
    capacity: null,
    route: {
      es: "Ouarzazate · Aït Ben Haddou · Dades · Alto Atlas · Todra · Erfoud · Erg Chebbi · Rissani · Valle del Ziz · Errachidia",
      en: "Ouarzazate · Aït Ben Haddou · Dades · High Atlas · Todra · Erfoud · Erg Chebbi · Rissani · Ziz Valley · Errachidia",
      fr: "Ouarzazate · Aït Ben Haddou · Dadès · Haut Atlas · Todra · Erfoud · Erg Chebbi · Rissani · Vallée du Ziz · Errachidia",
    },
    highlights: {
      es: ["Vuelo especial directo", "Ruta en 4x4 por el Alto Atlas y el Sahara", "Paseo en dromedario al atardecer", "Cena y Fiesta de Fin de Año en Kasbah Xaluca"],
      en: ["Special direct flight", "4x4 route through the High Atlas and Sahara", "Sunset camel ride", "New Year's Eve dinner and celebration at Kasbah Xaluca"],
      fr: ["Vol spécial direct", "Circuit en 4x4 dans le Haut Atlas et le Sahara", "Balade à dos de dromadaire au coucher du soleil", "Dîner et fête du Nouvel An à la Kasbah Xaluca"],
    },
    flights: {
      outbound: { es: "Barcelona → Ouarzazate", en: "Barcelona → Ouarzazate", fr: "Barcelone → Ouarzazate" },
      return: { es: "Errachidia → Barcelona", en: "Errachidia → Barcelona", fr: "Errachidia → Barcelone" },
    },
    accommodations: ["Hotel Xaluca Dades 4★", "Kasbah Xaluca · Erfoud", "Bivouac La Belle Étoile"],
    status: "featured",
  },
  {
    id: "easter-2026",
    badge: { es: "Semana Santa", en: "Easter", fr: "Pâques" },
    badgeColor: "#C16542",
    title: {
      es: "Erg Chebbi & Alto Atlas",
      en: "Erg Chebbi & High Atlas",
      fr: "Erg Chebbi & Haut Atlas",
    },
    dates: { es: "28 Mar – 04 Abr 2026", en: "28 Mar – 04 Apr 2026", fr: "28 Mars – 04 Avr 2026" },
    nights: { es: "7 noches · 8 días", en: "7 nights · 8 days", fr: "7 nuits · 8 jours" },
    image: "https://images.unsplash.com/photo-1542401886-65d6c61db217?auto=format&fit=crop&w=2000&q=85",
    price: 1990,
    deposit: 300,
    spots: 4,
    capacity: 12,
    route: { es: "Errachidia · Erg Chebbi · Todra · Dades · Ouarzazate",
             en: "Errachidia · Erg Chebbi · Todra · Dades · Ouarzazate",
             fr: "Errachidia · Erg Chebbi · Todra · Dadès · Ouarzazate" },
    highlights: {
      es: ["Bivouac de lujo en Erg Chebbi", "Música Gnawa en Khamlia", "Gargantas del Todra", "Cena pascua bereber"],
      en: ["Luxury bivouac in Erg Chebbi",  "Gnawa music in Khamlia",  "Todra Gorges",       "Berber Easter dinner"],
      fr: ["Bivouac de luxe à l'Erg Chebbi","Musique Gnawa à Khamlia","Gorges du Todra","Dîner pascal berbère"],
    },
    status: "open", // open | last | sold-out
  },
  {
    id: "summer-2026",
    badge: { es: "Verano", en: "Summer", fr: "Été" },
    badgeColor: "#D97742",
    title: {
      es: "Norte azul: Tánger – Chefchaouen – Fez",
      en: "Blue North: Tangier – Chefchaouen – Fez",
      fr: "Nord bleu : Tanger – Chefchaouen – Fès",
    },
    dates: { es: "12 Jul – 23 Jul 2026", en: "12 Jul – 23 Jul 2026", fr: "12 Juil – 23 Juil 2026" },
    nights: { es: "11 noches · 12 días", en: "11 nights · 12 days", fr: "11 nuits · 12 jours" },
    image: "https://images.unsplash.com/photo-1547234935-80c7145ec969?auto=format&fit=crop&w=2000&q=85",
    price: 2390,
    deposit: 400,
    spots: 6,
    capacity: 14,
    route: { es: "Tánger · Asilah · Chefchaouen · Volubilis · Meknès · Fez",
             en: "Tangier · Asilah · Chefchaouen · Volubilis · Meknès · Fez",
             fr: "Tanger · Asilah · Chefchaouen · Volubilis · Meknès · Fès" },
    highlights: {
      es: ["Pueblo azul al amanecer", "Mosaicos romanos de Volubilis", "Medina de Fez con guía local", "Cena en la kasbah de Tánger"],
      en: ["Blue town at sunrise", "Roman mosaics of Volubilis", "Fez medina with a local guide", "Dinner at Tangier kasbah"],
      fr: ["Village bleu à l'aube", "Mosaïques romaines de Volubilis", "Médina de Fès avec guide local", "Dîner à la kasbah de Tanger"],
    },
    status: "open",
  },
  {
    id: "fall-bridge-2026",
    badge: { es: "Puente Octubre", en: "October bridge", fr: "Pont d'octobre" },
    badgeColor: "#A07042",
    title: {
      es: "Ruta exprés Marrakech & Sahara",
      en: "Marrakech & Sahara express",
      fr: "Marrakech & Sahara express",
    },
    dates: { es: "10 Oct – 16 Oct 2026", en: "10 Oct – 16 Oct 2026", fr: "10 Oct – 16 Oct 2026" },
    nights: { es: "6 noches · 7 días", en: "6 nights · 7 days", fr: "6 nuits · 7 jours" },
    image: "https://images.unsplash.com/photo-1539020140153-e479b8c22e70?auto=format&fit=crop&w=2000&q=85",
    price: 1790,
    deposit: 300,
    spots: 8,
    capacity: 12,
    route: { es: "Marrakech · Alto Atlas · Aït Benhaddou · Erg Chebbi · Marrakech",
             en: "Marrakech · High Atlas · Aït Benhaddou · Erg Chebbi · Marrakech",
             fr: "Marrakech · Haut Atlas · Aït Benhaddou · Erg Chebbi · Marrakech" },
    highlights: {
      es: ["Kasbah de Aït Benhaddou (UNESCO)", "Noche en jaima de lujo", "Tagín en pueblo bereber", "Atlas Studios"],
      en: ["Aït Benhaddou kasbah (UNESCO)", "Night in a luxury caïdal tent", "Tagine in a Berber village", "Atlas Studios"],
      fr: ["Kasbah d'Aït Benhaddou (UNESCO)", "Nuit en tente caïdal de luxe", "Tajine dans un village berbère", "Atlas Studios"],
    },
    status: "open",
  },
  {
    id: "carnival-2027",
    badge: { es: "Carnaval", en: "Carnival", fr: "Carnaval" },
    badgeColor: "#5A6B4F",
    title: {
      es: "Escapada Drâa – Valle del Dades",
      en: "Drâa – Dades Valley escape",
      fr: "Escapade Drâa – Vallée du Dadès",
    },
    dates: { es: "10 Feb – 16 Feb 2027", en: "10 Feb – 16 Feb 2027", fr: "10 Fév – 16 Fév 2027" },
    nights: { es: "6 noches · 7 días", en: "6 nights · 7 days", fr: "6 nuits · 7 jours" },
    image: "https://images.unsplash.com/photo-1542401886-65d6c61db217?auto=format&fit=crop&w=2000&q=85",
    price: 1890,
    deposit: 300,
    spots: 10,
    capacity: 12,
    route: { es: "Marrakech · Drâa · Zagora · Dades · Marrakech",
             en: "Marrakech · Drâa · Zagora · Dades · Marrakech",
             fr: "Marrakech · Drâa · Zagora · Dadès · Marrakech" },
    highlights: {
      es: ["Valle de las mil kasbahs", "Palmeral del Drâa", "Pueblos trogloditas", "Hammam tradicional"],
      en: ["Valley of a thousand kasbahs", "Drâa palm grove", "Troglodyte villages", "Traditional hammam"],
      fr: ["Vallée des mille kasbahs", "Palmeraie du Drâa", "Villages troglodytes", "Hammam traditionnel"],
    },
    status: "open",
  },
  {
    id: "easter-2027",
    badge: { es: "Semana Santa", en: "Easter", fr: "Pâques" },
    badgeColor: "#C16542",
    title: {
      es: "Imperial: Fez, Meknès & Volubilis",
      en: "Imperial: Fez, Meknès & Volubilis",
      fr: "Impérial : Fès, Meknès & Volubilis",
    },
    dates: { es: "27 Mar – 03 Abr 2027", en: "27 Mar – 03 Apr 2027", fr: "27 Mars – 03 Avr 2027" },
    nights: { es: "7 noches · 8 días", en: "7 nights · 8 days", fr: "7 nuits · 8 jours" },
    image: "https://images.unsplash.com/photo-1570133435536-7ececf000ef6?auto=format&fit=crop&w=2000&q=85",
    price: 2190,
    deposit: 400,
    spots: 12,
    capacity: 14,
    route: { es: "Fez · Meknès · Volubilis · Chefchaouen · Tánger",
             en: "Fez · Meknès · Volubilis · Chefchaouen · Tangier",
             fr: "Fès · Meknès · Volubilis · Chefchaouen · Tanger" },
    highlights: {
      es: ["Curtidurías de Fez", "Volubilis al amanecer", "Cena en riad real", "Tour del té en Chefchaouen"],
      en: ["Fez tanneries", "Volubilis at sunrise", "Dinner in a royal riad", "Tea tour in Chefchaouen"],
      fr: ["Tanneries de Fès", "Volubilis à l'aube", "Dîner dans un riad royal", "Tour du thé à Chefchaouen"],
    },
    status: "open",
  },
];

export const UPCOMING_DEPARTURES = DEPARTURE_CATALOG.filter((departure) => departure.published === true);
